import axios from 'axios';

import apiSettings from '../config/apiSettings';

export default {
	getPing: () => axios.get(apiSettings.baseUrl + '/api/Probe'),
};